import {
  SET_AGENT_INFO_BY_CODE,
  SET_OPM_ASSIGNMENT_LIST,
  SET_AGENTS_UNDER_AD,
  SET_ELIGIBLE_POLICIES,
  SET_SUITABLE_AGENTS,
} from './constants';

export const initialState = {
  agentInfoByCode: null,
  opmAssignmentList: null,
  agentsUnderAd: [],
  eligiblePolicies: null,
  suitableAgents: [],
};

const opmReducers = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_AGENT_INFO_BY_CODE:
      state = {
        ...state,
        agentInfoByCode: payload,
      };
      break;
    case SET_OPM_ASSIGNMENT_LIST:
      state = {
        ...state,
        opmAssignmentList: payload,
      };
      break;
    case SET_AGENTS_UNDER_AD:
      state = {
        ...state,
        agentsUnderAd: payload,
      };
      break;
    case SET_ELIGIBLE_POLICIES:
      state = {
        ...state,
        eligiblePolicies: payload,
      };
      break;
    case SET_SUITABLE_AGENTS:
      state = {
        ...state,
        suitableAgents: payload,
      };
      break;
    default:
      break;
  }
  return state;
};

export default opmReducers;
